import React from 'react';
import './PaymentOverview.css';
import { formatNumber } from '../../../utils/analyticsHelpers';

const PaymentOverview = ({ paymentInitiated = 0, paymentSuccess = 0, paymentFailed = 0, bookingConfirmed = 0 }) => {
    return (
        <section className='analyticsSection paymentSection'>
            <div className='analyticsSectionHeader'>
                <div>
                    <h2>Payment Overview</h2>

                    <span>Payment activity</span>
                </div>
            </div>

            <div className='paymentStats'>
                <div>
                    <span>Initiated</span>

                    <strong>{formatNumber(paymentInitiated)}</strong>
                </div>

                <div>
                    <span>Successful</span>

                    <strong>{formatNumber(paymentSuccess)}</strong>
                </div>

                <div>
                    <span>Failed</span>

                    <strong>{formatNumber(paymentFailed)}</strong>
                </div>

                <div>
                    <span>Confirmed</span>

                    <strong>{formatNumber(bookingConfirmed)}</strong>
                </div>
            </div>
        </section>
    );
};

export default PaymentOverview;
